import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { useAddressLabel } from '../../hooks/use-address-label';
import FieldWrapper from '../../ui/field-wrapper';
import { TextField } from '../../ui/text-field';
import { useCountryCode } from '../multiline-address/multiline-address/country-code-context';
const MlaCity = props => {
  const fieldType = FIELD_TYPES.MLA_CITY;
  const label = useAddressLabel('city');
  const countryCode = useCountryCode();
  return /*#__PURE__*/React.createElement(FieldWrapper, {
    fieldType: fieldType,
    dataHook: props.target
  }, /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    fieldType: fieldType,
    label: label,
    countryCode: countryCode
  })));
};
export default MlaCity;
//# sourceMappingURL=mla-city.js.map